import "./NewsList.scss";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { baseUrl } from "../../../utils/apiData";
import {images} from "../../../utils/images";

const NewsList = ({ newsList }) => {

  return (
    <section className="news_events p_t">
       <img src={images.pattern} alt="Pattern" className="pattern_right" />
       <img src={images.pattern} alt="Pattern" className="pattern_left" />
        
      <div className="content_wrap">
        {newsList?.length > 0 ? (
          <div className="news_grid p_b">
            {newsList?.map((data) => {
                return (
                  <a href={data?.link} target="_blank" key={data?._id}>
                  <div
                    className="news_card"                 
                    
                  >
                    <div className="img_wrap">
                      <img
                        src={`${baseUrl}/${data?.image}`}
                        alt="News & Events"
                      />
                    </div>
                    <div className="info_wrap">
                      <p className="type gold">{data?.category?.name}</p>
                      <h5 className="gold">{data?.name}</h5>
                      <p className="type line gold">
                        {data?.publish_date} <HiOutlineArrowNarrowRight />
                      </p>
                    </div>
                  </div>
                  </a>
                );
              })}
          </div>
        ) : (
          <p className="text-center gold mb-5">Data not found...</p>
        )}
      </div>
    </section>
  );
};

export default NewsList;
